import React, { Component } from 'react';
import { Modal, Table, Radio, Icon, message } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import { CompareFilter as Filter } from './Filter';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SiteCompare from './SiteCompare';

const RadioGroup = Radio.Group;

class ConfigColumn extends Component {
    state = {
        visible: false,
        data: {},
        loading: false,
        percent: 30,
    }

    handleSubmit = () => {
        const { percent } = this.state;
        this.hide();
        this.props.setPercent(percent);
    }

    show = percent => {
        this.setState({
            percent,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    onChange = (e) => {
        this.setState({ percent: e.target.value });
    }

    render() {
        const { visible, confirmLoading, percent } = this.state;
        const radioStyle = {
            display: 'inline-block',
            height: '30px',
            lineHeight: '30px',
        };
        return (
            <Modal
                title="设置随机病例数排名%"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="condition-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                maskClosable={false}
                confirmLoading={confirmLoading}
            >
                <div>
                    <label style={{ display: "inline-block", verticalAlign: "top", lineHeight: "30px" }}>随机病例数排名%：</label>
                    <RadioGroup onChange={this.onChange} value={percent}>
                        <div>
                            <Radio style={radioStyle} value={10}>10%</Radio>
                            <Radio style={radioStyle} value={30}>30%</Radio>
                        </div>
                        <div>
                            <Radio style={radioStyle} value={50}>50%</Radio>
                            <Radio style={radioStyle} value={80}>80%</Radio>
                        </div>
                        <Radio style={radioStyle} value={100}>100%</Radio>
                    </RadioGroup>
                </div>
            </Modal>
        );
    }
}

class Compare extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        data: [],
        pagination: {
            current: 1,
            pageSize: 2,
        },
        loading: false,
        percent: 30,
        compareVisible: false,
        reCompare: true,
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({ loading: true });
        const { percent, sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            method: 'POST',
            url: API_URL.commentInfo.queryCommentInfo,
            data: {
                offset: current,
                limit: pageSize,
                percent,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options)
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: { ...params },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams, percent } = this.state;
        const dataOptions = {
            percent,
            ...sortParams,
            ...searchParams,
        };
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type: 'Comment_Info' },
            dataType: 'json',
            doneResult: res => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                dataOptions.asynchronousExportId = asynchronousExportId;
                ExportUtil.export(dataOptions, null, API_URL.export.exportCommentInfo);
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [];
        const { percent } = this.state;
        columns.push({
            title: (<div className="config_clm_oper"><span style={{ float: 'left' }}>{percent}%</span><Icon onClick={() => this.configPercent()} type="setting" style={{ float: "left", fontSize: "18px", marginLeft: "3px", color: "#5850C9" }} /></div>),
            dataIndex: 'holder',
            key: 'holder',
            width: 86,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
        }, {
            title: '项目名称',
            dataIndex: 'investigationSpecialName',
            key: 'investigationSpecialName',
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
        }, {
            title: '项目阶段',
            dataIndex: 'stageNames',
            key: 'stageNames',
        }, {
            title: '申办方',
            dataIndex: 'investigationSponsor',
            key: 'investigationSponsor',
            width: 151,
        });
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = (data || []).map((item, index) => (
            {
                index,
                ...item,
            }
        ));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    expandRowTitle = (record, type) => {
        const { data } = this.state;
        if (type == "expand") {
            data[record.index].expanded = true;
        } else {
            data[record.index].expanded = false;
        }
        this.setState({ data });
    }

    configPercent = () => {
        const { percent } = this.state;
        this.configColumnRef.show(percent);
    }

    setPercent = (percent) => {
        this.setState({
            percent
        }, () => {
            this.loadData()
        })
    }

    showCompare = () => {
        this.siteCompareRef.show();
    }

    render() {
        const { loading, pagination, percent, searchParams } = this.state;
        const expandedRowRender = (record) => {
            const columns = [
                {
                    title: record.expanded ? (<div
                        onClick={() => {
                            this.expandRowTitle(record)
                        }}
                    ><span className="ant-table-row-expand-icon ant-table-row-expanded"></span></div>) : (<div
                        onClick={() => {
                            this.expandRowTitle(record, 'expand')
                        }}
                    ><span className="ant-table-row-expand-icon ant-table-row-collapsed"></span></div>),
                    dataIndex: 'key', key: 'key', width: 85
                },
                { title: '城市', dataIndex: 'cityName', key: 'cityName', width: 140 },
                { title: '医院名称', dataIndex: 'hospitalName', key: 'hospitalName' },
                { title: '院区', dataIndex: 'courtyardArea', key: 'courtyardArea' },
                { title: '科室', dataIndex: 'hospitalDepartmentName', key: 'hospitalDepartmentName', width: 140 },
                {
                    title: 'PI姓名',
                    dataIndex: 'userCompellation',
                    key: 'userCompellation',
                    render: (text, record) => {
                        const { postStatus} = record;
                        return (
                            postStatus == "OFF" ?                   
                                <span>{text}(转岗)</span>
                            :
                                <span>{text}</span>
                        );
                    }, 
                    width: 140 },
                { title: 'PI联系电话', dataIndex: 'userMobile', key: 'userMobile', width: 140 },
                { title: '筛选病例数', dataIndex: 'filterAccount', key: 'filterAccount', width: 140 },
                { title: '随机病例数', dataIndex: 'randomAccount', key: 'randomAccount', width: 140 },
                { title: '中心启动时间', dataIndex: 'siteStartDate', key: 'siteStartDate', width: 150 },
                { title: '首病例入组（FPI）日期', dataIndex: 'fpiShow', key: 'fpiShow', width: 160 },
                { title: '末病例入组（LPI）日期', dataIndex: 'lpiShow', key: 'lpiShow', width: 160 },
                { title: 'open天数', dataIndex: 'openDay', key: 'openDay', width: 140 },
                { title: '月入组速率', dataIndex: 'rateOfEntry', key: 'rateOfEntry', width: 140 },
            ];
            const investigationSites = record.investigationSites || [];
            const data = [];
            if (record.expanded) {
                investigationSites.map((site, index) => {
                    data.push({
                        key: index + 1,
                        ...site,
                    })
                })
            } else {
                const length = investigationSites.length > 3 ? 3 : investigationSites.length;
                for (let i = 0; i < length; ++i) {
                    data.push({
                        key: i + 1,
                        ...investigationSites[i]
                    });
                }
            }
            return (
                <Table
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                />
            );
        };
        const expandedRowKeys = [0, 1];
        return (
            <div>
                <Filter
                    search={this.search}
                    export={this.export}
                    showCompare={this.showCompare}
                />
                <Table
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={record => record.index}
                    loading={loading}
                    scroll={{ x: 2010 }}
                    onChange={this.handleTableChange}
                    pagination={pagination}
                    expandedRowRender={expandedRowRender}
                    expandedRowKeys={expandedRowKeys}
                    expandIconAsCell={false}
                    expandIconColumnIndex={-1}
                    className="site_comment"
                />
                <ConfigColumn
                    percent={percent}
                    setPercent={this.setPercent}
                    ref={el => this.configColumnRef = el}
                />
                <SiteCompare ref={el => this.siteCompareRef = el} percent={percent} searchParams={searchParams} />
            </div>
        );
    }
}

export default Compare;


// WEBPACK FOOTER //
// ./src/components/siteComment/researchCenterRecommend/Compare.js